import router from "../router";

export default {
  methods: {
    kick: function() {
      localStorage.clear();
      router.push("/login");
    },
  },
};
